export const brandName = 'Midad CMS';
export const mainColor = '#084566'; // #084566
export const rtl = false;